// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contribute-view {
    box-sizing: border-box;
    max-width: 800px;
    min-width: 340px;
    width: 100%;

    font-size: 16px;
    line-height: 1.7em;
    margin: 0 auto;
}
.contribute-view__intro {
    max-width: 700px;
    margin: 0 auto;
}
.contribute-view h1 {
    text-align: center;
}
.contribute-view h2 {
    margin-top: 2em;
}
.contribute-view h3 {
    margin-top: 1.5em;
}
.contribute-view h4 {
    margin-top: 1em;
}
.contribute-view li {
    padding: 0.25em 0;
}

.contribute-view .contribution-grid {
    display: grid;
    margin: 50px auto 0 auto;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    align-items: center;
    justify-items: center;

}
.contribute-view .additional-contributions {
    margin: 20px auto;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/pages/about/views/Contribute.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;;IAEX,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,4DAA4D;IAC5D,mBAAmB;IACnB,qBAAqB;;AAEzB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".contribute-view {\n    box-sizing: border-box;\n    max-width: 800px;\n    min-width: 340px;\n    width: 100%;\n\n    font-size: 16px;\n    line-height: 1.7em;\n    margin: 0 auto;\n}\n.contribute-view__intro {\n    max-width: 700px;\n    margin: 0 auto;\n}\n.contribute-view h1 {\n    text-align: center;\n}\n.contribute-view h2 {\n    margin-top: 2em;\n}\n.contribute-view h3 {\n    margin-top: 1.5em;\n}\n.contribute-view h4 {\n    margin-top: 1em;\n}\n.contribute-view li {\n    padding: 0.25em 0;\n}\n\n.contribute-view .contribution-grid {\n    display: grid;\n    margin: 50px auto 0 auto;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    align-items: center;\n    justify-items: center;\n\n}\n.contribute-view .additional-contributions {\n    margin: 20px auto;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
